"use strict";

exports.log = function (s) {
  return function () {
    console.log(s);
    return {};
  };
};

exports.warn = function (s) {
  return function () {
    console.warn(s);
    return {};
  };
};

exports.error = function (s) {
  return function () {
    console.error(s);
    return {};
  };
};

exports.info = function (s) {
  return function () {
    console.info(s);
    return {};
  };
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-console/src/Control/Monad/Eff/Console.js
// module id = 67
// module chunks = 0